import { LogoWarppipe, SocialFacebook, SocialLinkedin, SocialTelegram, TextFooter } from '@/assets';
import ButtonAnimation from '@/components/common/ButtonAnimation';
import DownloadPortfolioModal from '@/components/common/Modal';
import {
  LinkBookCall,
  LinkPortfolio,
  LinkSocialFacebook,
  LinkSocialLinkedin,
  LinkSocialTelegram,
  LinkSubmitProject,
} from '@/constants/common';
import { ERoutePath } from '@/constants/route';
import useResponsive from '@/hooks/useResponsive';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  const isMobile = useResponsive();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const listLink = [
    {
      route: ERoutePath.HOME,
      title: t('Home'),
    },
    {
      route: ERoutePath.SOFTWARE_DEVELOPMENT_SERVICE,
      title: t('Software Development Service'),
    },
    {
      route: ERoutePath.CLIENT_APPLICATION_AREAS,
      title: t('Client & Application'),
    },
    {
      route: ERoutePath.CORE_SERVICES,
      title: t('Core Services'),
    },
    {
      route: LinkPortfolio,
      title: t('Portfolio'),
      isModal: true,
    },
    {
      route: ERoutePath.COMPANY_INFORMATION,
      title: t('Company Information'),
    },
  ];
  return (
    <footer className="footer-warppipe">
      <div className="footer-warppipe__top">
        <p className="title-footer">
          {t('The Optimal Technology Partner')}
          {!isMobile && <br />}
          {t('for Your Business Innovation')}
        </p>
        <div>
          <ButtonAnimation
            title={t('Book A Free Call')}
            onClick={() => window.open(LinkBookCall, '_blank')}
          />
          <ButtonAnimation
            title={t('Submit Project Inquiry')}
            onClick={() => window.open(LinkSubmitProject, '_blank')}
          />
        </div>
      </div>
      <div className="social-and-link">
        <div className="social-and-link__left">
          <div className="social-and-link__left-top">
            <p className="global-accessible">{t('Global Accessible')}</p>
            <div className="info-company">
              <div className="address-company">
                <p className="text-company">{t('Vietnam Head Office')}</p>
                <div className="desc-company">
                  <p>{t('Sky Tower, 17 Nguyen Chi Thanh Street, Ngoc Khanh, Ba Dinh, Hanoi')}</p>
                  <p>{t('Tel: (+84)-816-644-466')}</p>
                </div>
              </div>
              <div className="address-company">
                <p className="text-company">{t('Korea Office')}</p>
                <div className="desc-company">
                  <p>
                    {t(
                      '191, Dongbaekjungang-ro, Giheung-gu, Yongin-si, Gyeonggi-do, 8th floor, #8489 (Jung-dong, City Plaza)'
                    )}
                  </p>
                  <p>{t('Tel: (+82) 1688-7044')}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="social-and-link__left-bottom">
            <Link to="" className="link-logo">
              <LogoWarppipe />
            </Link>
            <div className="social-media">
              <a href={LinkSocialLinkedin} target="_blank" rel="noopener noreferrer">
                <SocialLinkedin />
              </a>
              <a href={LinkSocialFacebook} target="_blank" rel="noopener noreferrer">
                <SocialFacebook />
              </a>
              <a href={LinkSocialTelegram} target="_blank" rel="noopener noreferrer">
                <SocialTelegram />
              </a>
            </div>
          </div>
        </div>
        <div className="list-link">
          {listLink.map((item, index) => (
            <Link
              to={!item?.isModal ? item.route : location.pathname}
              className={`${item.route === location.pathname ? 'active' : ''} `}
              key={index}
              onClick={() => {
                if (!item?.isModal) window.scrollTo({ top: 0, behavior: 'smooth' });
                else {
                  setIsOpen(true);
                }
              }}
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
      <div className="text-warppipe">
        <TextFooter />
      </div>
      <DownloadPortfolioModal isOpen={isOpen} handleClose={() => setIsOpen(false)} />
    </footer>
  );
};

export default Footer;
